import { applyMiddleware, createStore, compose} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from "./RootReducer";
const NO_SHOW_INSTALL_PWA = 'NO_SHOW_INSTALL_PWA';


const LOCAL_STORAGE_NAME = "localData";

export function changeShowInstallPwa(data) {
    return {
        type: NO_SHOW_INSTALL_PWA,
        data,
    }
}

class store {

    // Singleton property
    static DefaultStore = null;

    // Accessor to the default instance of this class
    static getDefaultStore() {
        if (store.DefaultStore === null) {
            store.DefaultStore = new store();
        }

        return store.DefaultStore;
    }

    // Redux store
    _store = null;

    // When class instance is used, initialize the store
    constructor() {
        this.initStore()
    }

    // Initialization of Redux Store
    initStore() {
        // this._store = createStore(rootReducer, store.loadState());
        //  this._store = createStore(rootReducer,  store.loadState());
        // this._store = createStore(rootReducer, compose(applyMiddleware(thunk),  store.loadState()));
       // this._store = createStore(rootReducer, store.loadState(),compose(applyMiddleware(thunk)));
       this._store = createStore(rootReducer,compose(applyMiddleware(thunk)));
        this._store.subscribe(() => {
            store.saveState(this._store.getState());
        });
    }
    cloneAsObject(obj) {
        if (obj === null || !(obj instanceof Object)) {
            return obj;
        }
        var temp = (obj instanceof Array) ? [] : {};
        // ReSharper disable once MissingHasOwnPropertyInForeach
        for (var key in obj) {
            temp[key] = this.cloneAsObject(obj[key]);
        }
        return temp;
    }
    // Getter to access the Redux store
    get store() {
        return this._store;
    }

    // Loading persisted state from localStorage, no need to access
    // this method from the outside
    static loadState() {
        try {
            let serializedState = localStorage.getItem(LOCAL_STORAGE_NAME);

            if (serializedState === null) {
                return store.initialState();
            }

            return JSON.parse(serializedState);
        } catch (err) {
            return store.initialState();
        }
    }

    // Saving persisted state to localStorage every time something
    // changes in the Redux Store (This happens because of the subscribe()
    // in the initStore-method). No need to access this method from the outside
    static saveState(state) {
        try {
            let serializedState = JSON.stringify(this.cloneAsObject(state));
            localStorage.setItem(LOCAL_STORAGE_NAME, serializedState);
        } catch (err) {
        }
    }

    // Return whatever you want your initial state to be
    static initialState() {
        return {};
    }
}

store = store.getDefaultStore().store;
export default store;
